/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const colDefs = [
    {
        field: 'region',
        headerName: 'Region',
        sortable: true,
        filter: true,
        width: 110
    },
    {
        field: 'family',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 170,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=F&constraintkey=${params.value}`}>{params.value}</Link> )
    },
    {
        field: 'regionalGroup',
        headerName: 'Regional Group',
        sortable: true,
        filter: true,
        width: 170,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=G&constraintkey=${params.value}`}>{params.value}</Link> )
    },
    {
        field: 'priorityGroup',
        headerName: 'Priority Group',
        sortable: true,
        filter: true,
        width: 170,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=G&constraintkey=${params.value}`}>{params.value}</Link> )
    },
    {
        field: 'stockGroup',
        headerName: 'Stock Group',
        sortable: true,
        filter: true,
        width: 170,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=G&constraintkey=${params.value}`}>{params.value}</Link> )
    }
];

const regionColDefs = [
    {
        field: 'region',
        headerName: 'Region',
        sortable: true,
        filter: true,
        width: 110
    },
    {
        field: 'unit',
        headerName: 'Unit',
        sortable: true,
        filter: true,
        width: 110
    },
    {
        field: 'name',
        headerName: 'Name',
        sortable: true,
        filter: true,
        width: 460
    }
];

export const PriorityReservationInquiryTable = props => (

    <section className="atp-search-result-panel priority-reservation-inquiry-result-1st-panel ">

        <div className="results-message">
            {`Priority Reservation as of  ${new Date()}`}
        </div>

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

PriorityReservationInquiryTable.propTypes = {
    results: PropTypes.array.isRequired
};

export const RegionPriorityReservationInquiryTable = props => (

    <section className="atp-search-result-panel priority-reservation-inquiry-result-2nd-panel ">
        <div className="results-message">
            {`Region Inquiry as of ${new Date()}`}
        </div>
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={regionColDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

RegionPriorityReservationInquiryTable.propTypes = {
    results: PropTypes.array.isRequired
};
